import styled from 'styled-components'

export const OntarioRow = styled.div`
  margin: 0 auto;
  max-width: 72rem;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 40em) {
    flex-direction: row;
  }
`

export const OntarioColumn = styled.div`
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
`
